import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

interface DesignRecord {
  orderItemId: string;
  productName: string;
  destinationProductLink: string;
  destinationProductThumbnail: string;
  sku: string;
}

@Component({
  selector: 'app-design-search',
  templateUrl: './design-search.component.html',
  styleUrls: ['./design-search.component.css']
})
export class DesignSearchComponent implements OnInit, OnDestroy {
  @Input() placeholder: string = 'Tìm kiếm thiết kế...';
  @Output() designSelected = new EventEmitter<DesignRecord>();

  searchKeyword: string = '';
  searchResults: DesignRecord[] = [];
  isLoading: boolean = false;
  showResults: boolean = false;
  private searchTimeout: any;

  constructor(private http: HttpClient) {}

  ngOnInit(): void {}

  ngOnDestroy(): void {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
  }

  onSearchInput(event: any): void {
    const keyword = event.target.value.trim();
    
    // Clear previous timeout
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }

    // Set new timeout for debounced search
    this.searchTimeout = setTimeout(() => {
      this.performSearch(keyword);
    }, 300);
  }

  performSearch(keyword: string): void {
    if (!keyword || keyword.length < 2) {
      this.searchResults = [];
      this.showResults = false;
      return;
    }

    this.isLoading = true;
    this.showResults = true;

    // Search for records with non-empty Destination Product Link
    this.http.get<DesignRecord[]>(`/api/SaleRecord/searchDesigns`, {
      params: { keyword: keyword }
    }).subscribe({
      next: (results) => {
        this.searchResults = results;
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error searching designs:', error);
        this.searchResults = [];
        this.isLoading = false;
      }
    });
  }

  selectDesign(design: DesignRecord): void {
    this.designSelected.emit(design);
    this.showResults = false;
    this.searchKeyword = design.productName;
  }

  onFocus(): void {
    if (this.searchResults.length > 0) {
      this.showResults = true;
    }
  }

  onBlur(): void {
    // Delay hiding results to allow for click events
    setTimeout(() => {
      this.showResults = false;
    }, 200);
  }

  clearSearch(): void {
    this.searchKeyword = '';
    this.searchResults = [];
    this.showResults = false;
  }
}
